export const homeAbout = [
  {
    id: 1,
    cover: "https://img.icons8.com/dotty/80/000000/storytelling.png",
    title: "Online Courses",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/diploma.png",
    title: "Earn A Certificates",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    id: 1,
    cover: "https://img.icons8.com/ios/80/000000/athlete.png",
    title: "Learn with Expert",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
]
export const awrapper = [
  {
    cover: "https://img.icons8.com/external-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto/80/ffffff/external-graduation-education-yogi-aprelliyanto-basic-outline-yogi-aprelliyanto.png",
    data: "3,000",
    title: "SUCCESS STORIES",
  },

  {
    cover: "https://img.icons8.com/ios/80/ffffff/athlete.png",
    data: "320",
    title: "TRUSTED TUTORS",
  },
  {
    cover: "https://img.icons8.com/external-outline-icons-maxicons/80/ffffff/external-calender-insurance-outline-outline-icons-maxicons.png",
    data: "1,000",
    title: "SCHEDULES",
  },
  {
    cover: "https://img.icons8.com/ios/80/ffffff/macbook-idea--v3.png",
    data: "587",
    title: "COURSES",
  },
]
export const coursesCard = [
  {
    id: 1,
    cover: "../images/courses/c1.png",
    coursesName: "Introducing to Software Engineering",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by John Smith",
        totalTime: "50 lectures (190 hrs)",
      },
    ],
    priceAll: "$100 All Course",
    pricePer: "$15 per month",
  },
  {
    id: 2,
    cover: "../images/courses/c2.png",
    coursesName: "Enhancing Adobe Photoshop CC 2020 Skills",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Ram Gurung",
        totalTime: "30 lectures (125 hrs)",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$25 per month",
  },
  {
    id: 3,
    cover: "../images/courses/c3.png",
    coursesName: "HTML, CSS, and Javascript for Web Developers",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Saroj Nepal",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "$50 All Course",
    pricePer: "$5 per month",
  },
  {
    id: 4,
    cover: "../images/courses/c4.png",
    coursesName: "Introducing to Programming with WordPress",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Prabin Thapa Mager",
        totalTime: "20 lectures (20 hrs)",
      },
    ],
    priceAll: "$30 All Course",
    pricePer: "$3 per month",
  },
  {
    id: 5,
    cover: "../images/courses/c5.png",
    coursesName: "Introducing to Programming with ReactJS",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Sunil Bishowkaram",
        totalTime: "100 lectures (150 hrs)",
      },
    ],
    priceAll: "$300 All Course",
    pricePer: "$30 per month",
  },
  {
    id: 6,
    cover: "../images/courses/c6.png",
    coursesName: "Learn Frontend Programming Language",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Sunil Bishowkaram",
        totalTime: "200 lectures (300 hrs)",
      },
    ],
    priceAll: "$500 All Course",
    pricePer: "$80 per month",
  },
  {
    id: 7,
    cover: "../images/courses/c7.png",
    coursesName: "Introducing to with HTML / CSS",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Price",
        totalTime: "20 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$2 per month",
  },
  {
    id: 8,
    cover: "../images/courses/c8.png",
    coursesName: "Introducing to with JAVA",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Petter",
        totalTime: "80 lectures (200 hrs)",
      },
    ],
    priceAll: "$200 All Course",
    pricePer: "$40 per month",
  },
  {
    id: 9,
    cover: "../images/courses/c9.png",
    coursesName: "Introducing to with HTML / CSS / JAVASCRIPT",
    courTeacher: [
      {
        dcover: "./images/back.webp",
        name: "by Petter",
        totalTime: "50 lectures (50 hrs)",
      },
    ],
    priceAll: "$20 All Course",
    pricePer: "$3 per month",
  },
]
export const online = [
  {
    cover: "./images/courses/online/o1.png",
    hoverCover: "./images/courses/online/o1.1.png",
    courseName: "UI/UX Design Courses",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o2.png",
    hoverCover: "./images/courses/online/o2.1.png",
    courseName: "Art & Design",
    course: "25 Courses",
  },
  {
    cover: "./images/courses/online/o3.png",
    hoverCover: "./images/courses/online/o3.1.png",
    courseName: "Computer Science",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o4.png",
    hoverCover: "./images/courses/online/o4.1.png",
    courseName: "History & Archeologic",
    course: "15 Courses",
  },
  {
    cover: "./images/courses/online/o5.png",
    hoverCover: "./images/courses/online/o5.1.png",
    courseName: "Software Engineering",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o6.png",
    hoverCover: "./images/courses/online/o6.1.png",
    courseName: "Information Software",
    course: "60 Courses",
  },
  {
    cover: "./images/courses/online/o7.png",
    hoverCover: "./images/courses/online/o7.1.png",
    courseName: "Health & Fitness",
    course: "10 Courses",
  },
  {
    cover: "./images/courses/online/o8.png",
    hoverCover: "./images/courses/online/o8.1.png",
    courseName: "Marketing",
    course: "30 Courses",
  },
  {
    cover: "./images/courses/online/o9.png",
    hoverCover: "./images/courses/online/o9.1.png",
    courseName: "Graphic Design",
    course: "80 Courses",
  },
  {
    cover: "./images/courses/online/o10.png",
    hoverCover: "./images/courses/online/o10.1.png",
    courseName: "Music",
    course: "120 Courses",
  },
  {
    cover: "./images/courses/online/o11.png",
    hoverCover: "./images/courses/online/o11.1.png",
    courseName: "Business Administration",
    course: "17 Courses",
  },
  {
    cover: "./images/courses/online/o12.png",
    hoverCover: "./images/courses/online/o12.1.png",
    courseName: "Web Management",
    course: "17 Courses",
  },
]
export const team = [
  {
    cover: "./images/team/Adams238-2.jpg",
    name: "Dr. Stephanie G. Adams",
    work: "JONSSON SCHOOL DEAN",
  },
  {
    cover: "./images/team/balsara.jpg",
    name: "Dr. Poras T. Balsara",
    work: "JONSSON SCHOOL VICE DEAN",
  },
  {
    cover: "./images/team/Dinesh-Bhatia-224.jpg",
    name: "Dr. Dinesh Bhatia",
    work: "HEAD OF ELECTRICAL AND COMPUTER ENGINEERING",
  },
  {
    cover: "./images/team/Daescu.jpg",
    name: "Dr. Ovidiu Daescu",
    work: "HEAD OF COMPUTER SCIENCE",
  },
  {
    cover: "./images/team/Prasad.jpg",
    name: "Dr. Shalini Prasad",
    work: "HEAD OF BIOENGINEERING",
  },
  {
    cover: "./images/team/Quevedo-Lopez.jpg",
    name: "Dr. Manuel Quevedo-Lopez",
    work: "HEAD OF MATERIALS SCIENCE AND ENGINEERING",
  },
  {
    cover: "./images/team/Rencis.jpg",
    name: "Dr. Joseph J. Rencis",
    work: "INTERIM HEAD OF MECHANICAL ENGINEERING",
  },
  {
    cover: "./images/team/Yurkovich.jpg",
    name: "Dr. Stephen Yurkovich",
    work: "HEAD OF SYSTEMS ENGINEERING",
  },
]
export const price = [
  {
    name: "BASIC PLAN",
    price: "49K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "BEGINNER PLAN",
    price: "79K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "PREMIUM PLAN",
    price: "109k",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
  {
    name: "ULTIMATE PLAN",
    price: "149K",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
  },
]
export const faq = [
  {
    title: "How do I add, drop, or swap classes?",
    desc: "Go to Galaxy and enter the Orion page. From there, enter the 'Manage my Classes' page. In the drop down menu on the left hand side, students will be given the option to add, drop, or swap classes.",
  },
  {
    title: "How do I transfer credits from other colleges or placement tests?",
    desc: "AP, Dual Credit, and Community College credit can be transferred to UTD if the following criteria is met. Use the course equivalency tool on the UTD website to determine if credit will be given. For AP scores, check the UTD website to find the minimum required score. Send all official transcrips and test results to UTD and check Galaxy for updates on your transfer.",
  },
  {
    title: "How can I change my degree?",
    desc: "Any changes done to your major or minor are done through Galaxy. In Orion, go to the 'My Academics' page, and then go to the 'View/Request Plan Change' tab. Keep in mind, any changes must be approved by an advisor and are not guaranteed.",
  },
  {
    title: "Does UTD offer online courses?",
    desc: "UTD schools offer many online or blended/hybrid courses. To learn more about each school's offering, please contact the school directly. You can also search for distance learning courses on coursebook. To lookup a course, go to CourseBook, enter your search criteria (for example: Term, School, and Class level), and for Distance Learning courses, select the Instruction Method as 'Online' or 'Blended/Hybrid', then click Search.",
  },
  {
    title: "What skills will I need before starting my Engineering degree?",
    desc: "Engineering classes are built on a strong foundation of math and science, particularly calculus and physics. You will want to take as many math classes as possible and try to get to trigonometry, pre-calculus and calculus if you can before graduation. If your school doesn’t offer calculus, then take Introduction to College Math. Many schools are also beginning to offer engineering classes and programs. These programs may give you more exposure to engineering and help you decide if it is the right choice for you.",
  },
  {
    title: "Does UTD have engineering based organizations and extracurriculars?",
    desc: "Yes! UTD offers many engineering based clubs and organizations to help every student get involved on campus. Visit the Jonsson School student organization page for a detailed view of all the available organizations.",
  },
]
export const blog1 = [
  {
    id: 1,
    type: "admin",
    date: "JAN. 18, 2021",
    com: "3 COMMENTS ",
    title: "Setting Up Github",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b1.webp",
  },
  {
    id: 2,
    type: "admin",
    date: "API. 25, 2022",
    com: "5 COMMENTS ",
    title: "Setting Up VS Code",
    desc: "A small river named Duden flows by their place and supplies it with the necessary regelialia.",
    cover: "../images/blog/b2.webp",
  },
]
export const blog = [
  {
    id: 1,
    type: "admin",
    date: "JAN. 18, 2021",
    com: "3 COMMENTS ",
    title: "Setting Up Github",
    desc: "GitHub is a developer platform that allows developers to create, store, manage and share their code. This platform will be useful when collaborating on assignments or projects.",
    cover: "../images/blog/Github.png",
    link:"https://docs.github.com/en/get-started/getting-started-with-git/set-up-git",
  },
  {
    id: 2,
    type: "admin",
    date: "API. 25, 2022",
    com: "5 COMMENTS ",
    title: "Setting Up VS Code",
    desc: "Visual Studio Code is a source-code editor developed by Microsoft for Windows, Linux and macOS. Features include support for debugging, syntax highlighting, intelligent code completion, snippets, code refactoring, and embedded Git.",
    cover: "../images/blog/VSCode.jpg",
    link:"https://code.visualstudio.com/learn/get-started/basics",
  },
  {
    id: 3,
    type: "admin",
    date: "API. 25, 2022",
    com: "5 COMMENTS ",
    title: "Setting Up LinkedIn",
    desc: "LinkedIn is a business and employment-focused social media platform that works through websites and mobile apps. This platform will help you build vital connections with people in the industry of your choice.",
    cover: "../images/blog/LinkedIn.png",
    link:"https://www.linkedin.com/pulse/linkedin-beginner-all-star-8-easy-steps-clifford-wessel/",
  },
]
export const testimonal = [
  {
    id: 1,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t1.webp",
  },
  {
    id: 2,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t2.webp",
  },
  {
    id: 3,
    name: "ROGER SCOTT",
    post: "MARKETING MANAGER",
    desc: "Far far away, behind the word mountains, far from the countries Vokalia and Consonantia, there live the blind texts.",
    cover: "./images/testo/t3.webp",
  },
]
